import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import { store, initStore } from './store/index'
import './plugins'
import * as filters from './filters'
import './assets/styles/index.scss'
import ElementUI from 'element-ui' // 全局引入element
import 'element-ui/lib/theme-chalk/index.css'
// 引入quill-editor编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 实现quill-editor编辑器拖拽上传图片
import * as Quill from 'quill'
import { ImageDrop } from 'quill-image-drop-module'
import { urls } from '@api/allapi' // 全局引入element的样式
Vue.config.productionTip = false

Vue.use(VueQuillEditor)

Quill.register('modules/imageDrop', ImageDrop)

Vue.prototype.$baseUrl = urls

/* 定义全局过滤器 */
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    initStore()
  }
}).$mount('#app')
